import React from "react";

import logo from "../../assets/images/logo.png";

class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="header">
        <div className="headerInner">
          <aside className="siteLogo">
            <a href={process.env.REACT_APP_EXTERNAL_HOMEPAGE} target="_blank">
              <img src={logo} className="img-fluid marcusLogo" alt="Marcus THEATRES" />
            </a>
          </aside>
        </div>
      </div>
    );
  }
}

export default Header;
